import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const AssistantPage = lazy(() =>
  import('./components/AssistantPage').then((m) => ({ default: m.AssistantPage })),
);

/**
 * The Xtremand AI Assistant, reached from the pinned link at the foot of the sidebar rail.
 *
 * <p>Listed beside the support routes in `app/router`: like support, it belongs to the account and not
 * to a product.
 */
export const assistantRoutes: RouteObject[] = [
  { path: ROUTES.aiAssistant, element: <AssistantPage /> },
];
